module.exports = __webpack_public_path__ + "img/check.f1bc99d5.svg";